module.exports = __webpack_public_path__ + "img/home-marker.9113e4d.png";